import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ItemsRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: ItemsRow[];
  loading?: boolean;
};

const displayValue = (value: string | number) =>
  value === null || value === "" ? "-" : String(value);

const ItemsTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "itemName",
        label: t("ITEMS.TABLE.ITEM"),
        align: "right",
        format: (row: ItemsRow) => (
          <span className={styles.textCell}>{displayValue(row.itemName)}</span>
        ),
      },
      {
        id: "itemDesc",
        label: t("ITEMS.TABLE.DETAILED_DESCRIPTION"),
        align: "right",
        format: (row: ItemsRow) => (
          <span className={styles.textCell}>{displayValue(row.itemDesc)}</span>
        ),
      },
      {
        id: "height",
        label: t("ITEMS.TABLE.HEIGHT"),
        align: "right",
        format: (row: ItemsRow) => (
          <span className={styles.textCell}>{displayValue(row.height)}</span>
        ),
      },
      {
        id: "width",
        label: t("ITEMS.TABLE.WIDTH"),
        align: "right",
        format: (row: ItemsRow) => (
          <span className={styles.textCell}>{displayValue(row.width)}</span>
        ),
      },
      {
        id: "length",
        label: t("ITEMS.TABLE.LENGTH"),
        align: "right",
        format: (row: ItemsRow) => (
          <span className={styles.textCell}>{displayValue(row.length)}</span>
        ),
      },
      {
        id: "thick",
        label: t("ITEMS.TABLE.THICKNESS"),
        align: "right",
        format: (row: ItemsRow) => (
          <span className={styles.textCell}>{displayValue(row.thick)}</span>
        ),
      },
      {
        id: "weight",
        label: t("ITEMS.TABLE.WEIGHT"),
        align: "right",
        format: (row: ItemsRow) => (
          <span className={styles.textCell}>{displayValue(row.weight)}</span>
        ),
      },
      {
        id: "itemType",
        label: t("ITEMS.TABLE.GROUP"),
        align: "right",
        format: (row: ItemsRow) => (
          <span className={styles.textCell}>{displayValue(row.itemType)}</span>
        ),
      },
      {
        id: "remarks",
        label: t("ITEMS.TABLE.NOTES"),
        align: "right",
        format: (row: ItemsRow) => (
          <span className={styles.textCell}>{displayValue(row.remarks)}</span>
        ),
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root} dir="rtl">
      <DataTable
        rows={rows}
        columns={columns}
        scrollClass={styles.tableScroll}
        loading={loading && rows.length === 0}
        serialEnabled={false}
        noDataLabel={t("ITEMS.EMPTY")}
      />
    </div>
  );
};

export default ItemsTable;
